var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"position-fixed-full z-index-layer"},[_c('div',{staticClass:"bg-layer z-index-bg"}),_c('div',{staticClass:"position-relative flex-column justify-center full-width full-height z-index-contents pa-10",staticStyle:{"margin":"0 auto"},style:('max-width:' + (_vm.max ? _vm.max : '480') + 'px')},[_vm._t("body")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }